import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import GoogleLogin from 'src/components/common/google-login';
import Loader from 'src/components/common/loader';
import TextError from 'src/components/ui/text-error';

import authStore from 'src/stores/auth-store';

import { GoogleOAuthProvider } from 'src/contexts';
import { APP_NAME, IS_HEBREW_INSTALLATION } from 'src/constants';

import './login-page.scss';

const LoginPage = observer(() => {
  const { authError, isLoading, authenticateUser, setGoogleAuthError } = authStore;

  return (
    <GoogleOAuthProvider clientId={window.GOOGLE_OAUTH_CLIENT_ID}>
      <div className={classNames('login-page', IS_HEBREW_INSTALLATION && 'login-page_hebrew')}>
        {isLoading && <Loader position="overlay" />}
        <div className="login-page__container">
          <div className="login-page__content">
            <div className="login-page__info-container">
              <img
                className="login-page__logo"
                src={`/logos/${IS_HEBREW_INSTALLATION ? 'bezikaron-logo.svg' : 'afs-logo.svg'}`}
                width={148}
                height={148}
                alt={IS_HEBREW_INSTALLATION ? 'Bezikaron logo' : 'All Funeral Services logo'}
              />
              <div className="login-page__text-wrapper">
                <h1 className="login-page__title">{APP_NAME}</h1>
                <span className="login-page__text">Please sign in to continue</span>
              </div>
              <GoogleLogin
                size="large"
                width={400}
                onSuccess={authenticateUser}
                onError={setGoogleAuthError}
              />
              {authError && <TextError textError={authError} />}
            </div>

            <img
              className="login-page__logo-full"
              src={`/logos/${
                IS_HEBREW_INSTALLATION ? 'bezikaron-logo-full.svg' : 'afs-logo-full.svg'
              }`}
              alt={IS_HEBREW_INSTALLATION ? 'Bezikaron logo' : 'All Funeral Services logo'}
            />
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
});

export default LoginPage;
